import { ReactNode } from 'react';
import { SM_VIEWPORT } from '@constants/viewport';

export type ModalCloseSource = 'backdrop' | 'drag';

/** Returns true when the close was triggered by an implicit gesture (backdrop/drag) on a mobile viewport. */
export const isMobileImplicitDismiss = (source?: ModalCloseSource): boolean =>
  (source === 'backdrop' || source === 'drag') && window.innerWidth < SM_VIEWPORT;

export interface ModalV2Props {
  // Core (required)
  isOpen: boolean;
  onClose: (source?: ModalCloseSource) => void;
  children: ReactNode;

  // Variants
  variant?: 'sm' | 'md' | 'lg' | 'xl' | 'full';

  // Mobile features
  hasMobileHandle?: boolean;
  enableDragToClose?: boolean;

  // Styling
  maxWidthClass?: string;
  borderRadiusClass?: string;
  overlayClassName?: string;
  contentClassName?: string;

  // Behavior
  closeOnBackdropClick?: boolean;
  closeOnEscape?: boolean;

  // Advanced
  enableMultipleModals?: boolean;
  zIndex?: number;

  // Lifecycle
  onAfterLeave?: () => void;

  // Accessibility
  ariaLabel?: string;
}

// For the drag-to-close hook
export interface DragToCloseOptions {
  isOpen: boolean;
  onClose: (source?: ModalCloseSource) => void;
  enabled?: boolean;
  threshold?: number;
  closingAnimationDuration?: number;
}

export interface UseDragToCloseReturn {
  panelRef: React.RefObject<HTMLDivElement>;
  isClosing: boolean;
  handleTouchStart: (e: React.TouchEvent) => void;
  handleTouchMove: (e: React.TouchEvent) => void;
  handleTouchEnd: () => void;
  handleTouchCancel: () => void;
  initiateClose: (source?: ModalCloseSource) => void;
}
